<h1 class="page-title mb-5"> مسابقة التميز في مجال التنمية المستدامة لعام 2023 </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <p>​تعقد الإدارة المركزية حاليا ندوة تعريفية عن المسئولية المجتمعية وتكافؤ الفرص شهريا عبر الإنترنت من
                    خلال تطبيق زووم,

                    للمشاركة وحضور الندوة التسجيل من خلال الرابط التالي: </p>
                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLScVwy-KqZ6u2tEv8XSp5cZCon9prSW3PEpMRHBbyXyiLB1iTw/viewform">
                    تسجيل للندوة
                </a>
                <ul class="mt-5">
                    <li><a
                            href="https://docs.google.com/forms/d/1tCYeQK4zaj9HAou2ewNYrsgh_eM4zDDn84ZJOn0oogQ/viewform?edit_requested=true">
                            ورشة عمل للتعريف بقانون تنظيم ممارسة العمل الأهلي ولائحته التنفيذية والقوانين ذات الصلة
                            (تقام يوم 21/2/2023)</a></li>
                    <li><a
                            href="https://docs.google.com/forms/d/1IoYK7NN-Qj-bWeUqjW99mFwbU3HDcq5_NOMoCBm5zJM/viewform?edit_requested=true">
                            ورشة عمل حول الخدمات المقدمة من الهيئة العامة للاستثمار والمناطق الحرة (تقام في شهر مارس)
                        </a></li>
                </ul>
            </div>


            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>